import { AfterViewChecked, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';
import { CbreIconLoaderService } from '@shared/services/cbre-icon-loader.service';
@Component({
  selector: 'miq-footer',
  template: `
    <mat-toolbar>
      <!-- LOGO -->
      <div class="footer cbre-logo" [innerHTML]="svg"></div>
      <span class="registration" i18n>Powered by EDP</span>
      <!-- MIDDLE EMPTY SPACE -->
      <span class="empty-space"></span>
      <!-- COPY RIGHT -->
      <span class="copyright"
        ><span>{{ today | date: 'yyyy' }} </span> <span class="copyright" l10nTranslate>admin.copyright</span></span
      >
    </mat-toolbar>
  `,
  styleUrls: ['./footer.component.scss'],
  standalone: false,
})
export class FooterComponent implements OnInit, AfterViewChecked {
  public today = new Date();
  public svg: SafeHtml;

  constructor(
    private cbreIcons: CbreIconLoaderService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.svg = this.cbreIcons.getTrustedIcon('cbre-logo');
  }

  ngAfterViewChecked(): void {
    this.cdr.detach();
  }
}
